import { TypeOrmMappedOperator } from "../models";

/**
 * The operator and the number are stored as one string, so the pair travels through the filter
 * store — which holds a flat array of values per filter — without needing its own shape.
 */
export const NUMBER_COMPARISON_SEPARATOR = ":";

/**
 * What the comparison filter offers, and what each choice means to the API.
 *
 * The symbol and its criteria operator are declared together on purpose. They used to live
 * apart — the dropdown knew the symbols and nothing knew how to turn them into criteria — so
 * the filter encoded "=:3", the criteria builder wrapped it in `$in` because that is the
 * default, and the API was asked for rows where an integer column equalled the text "=:3".
 */
export const NUMBER_COMPARISON_OPERATORS: {
  value: string;
  label: string;
  criteria: TypeOrmMappedOperator;
}[] = [
  { value: "<", label: "<", criteria: "$lt" },
  { value: "<=", label: "≤", criteria: "$lte" },
  { value: "=", label: "=", criteria: "$eq" },
  { value: ">=", label: "≥", criteria: "$gte" },
  { value: ">", label: ">", criteria: "$gt" },
];
